<div class="login-page" [class.has-backdrop]="brand.loginBackground">
  <div class="login-backdrop" *ngIf="brand.loginBackground">
    <picture>
      <source srcset="./assets/background.webp" type="image/webp" />
      <img src="./assets/background.jpg" class="login-bg-image" alt="" decoding="async" fetchpriority="low" />
    </picture>
  </div>

  <div class="login-container">
    <div class="login-card">
      <img
        class="login-logo"
        [src]="brand.logo"
        [alt]="brand.productName"
        decoding="async" />

      <h1 class="login-title">Create Account</h1>
      <p class="login-subtitle">Create your {{ brand.productName }} sign-in. Profile details are requested when you start trial or course access.</p>

      <div *ngIf="message" class="alert alert-success login-error" role="status">
        <i class="bi bi-check-circle login-error-icon" aria-hidden="true"></i>
        <div class="login-error-body">
          <p class="login-error-text mb-0">{{ message }}</p>
        </div>
      </div>

      <div *ngIf="error" class="alert alert-danger login-error" role="alert">
        <i class="bi bi-exclamation-circle login-error-icon" aria-hidden="true"></i>
        <div class="login-error-body">
          <p class="login-error-text mb-0">{{ error }}</p>
        </div>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form mb-3">
        <div class="form-group">
          <label class="form-label" for="signup-email">Email</label>
          <input
            id="signup-email"
            type="email"
            class="form-control"
            formControlName="email"
            autocomplete="username"
            placeholder="you@example.com"
            [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched" />
          <div class="invalid-feedback d-block" *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
            Use an email address such as name&#64;example.com.
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="signup-password">Password</label>
          <input
            id="signup-password"
            type="password"
            class="form-control"
            formControlName="password"
            autocomplete="new-password"
            placeholder="Password"
            [class.is-invalid]="form.get('password')?.invalid && form.get('password')?.touched" />
          <div class="invalid-feedback d-block" *ngIf="form.get('password')?.invalid && form.get('password')?.touched">
            Password must be at least 6 characters.
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="signup-confirm">Confirm Password</label>
          <input
            id="signup-confirm"
            type="password"
            class="form-control"
            formControlName="confirmPassword"
            autocomplete="new-password"
            placeholder="Confirm password"
            [class.is-invalid]="(form.get('confirmPassword')?.invalid || form.errors?.['mismatch']) && form.get('confirmPassword')?.touched" />
          <div class="invalid-feedback d-block" *ngIf="form.errors?.['mismatch'] && form.get('confirmPassword')?.touched">
            Passwords do not match.
          </div>
        </div>

        <div class="form-check text-start mb-3">
          <input id="signup-terms" class="form-check-input" type="checkbox" formControlName="termsAccepted">
          <label class="form-check-label small" for="signup-terms">
            I accept the <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge the
            <a routerLink="/privacy" target="_blank">Privacy Notice</a>.
          </label>
          <div class="invalid-feedback d-block" *ngIf="form.get('termsAccepted')?.invalid && form.get('termsAccepted')?.touched">
            You must accept the terms to create an account.
          </div>
        </div>

        <button type="submit" class="btn btn-primary login-btn" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
          Create account
        </button>
      </form>

      <p class="small text-center mb-0">
        Already have an account? <a routerLink="/login">Sign in</a>
      </p>
      <app-legal-footer></app-legal-footer>
    </div>
  </div>
</div>
